import { useState } from "react";
import axios from "axios";
import { setSessionData } from "../utils/session";

export default function LoginForm() {
    const [username, setUsername] = useState("");
    const [password, setPassword] = useState("");
    const [error, setError] = useState("");

    const login = async (e) => {
        e.preventDefault();
        const encoded = btoa(`${username}:${password}`);
        try {
            const response = await axios.get(`${process.env.REACT_APP_API_URL}/authenticate`, {
                headers: {
                    Authorization: `Basic ${encoded}`
                },
            });
            let ibmToken = "";
            const user = response.data.user;
            const userId = response.data.userId;
            const ibmRestricted = response.data.ibmRestricted;
            const xtvmAllowed = response.data.xtvmAllowed;
            const altDataAllowed = response.data.altDataAllowed;
            const ibmAllowed = response.data.ibmAllowed;

            const rawProfilerUrl = process.env.REACT_APP_PROFILER_URL || 'https://3di-profiler.net/authServlet?username=[username]&password=[password]&redirect=[redirectid]';
            const profilerUrl = rawProfilerUrl
                .replace('[username]', encodeURIComponent(username))
                .replace('[password]', encodeURIComponent(password));

            setSessionData({
                token: response.data.token,
                ibmToken,
                user,
                userName: username,
                userId,
                profilerUrl,
                ibmRestricted,
                xtvmAllowed,
                altDataAllowed,
                ibmAllowed,
            });
            alert(`Welcome ${response.data.user}`);
        } catch (err) {
            setError("Invalid credentials");
        }
    };


    return (
        <form onSubmit={login}>
            <input value={username} onChange={e => setUsername(e.target.value)} placeholder="Username" />
            <input type="password" value={password} onChange={e => setPassword(e.target.value)} placeholder="Password" />
            <button type="submit">Login</button>
            {error && <p>{error}</p>}
        </form>
    );
}
